import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function KidsSpecialEventsDecorationMenu() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const containerRef = useExecScripts();

  return (
    <div id="content" className="site-content">
      <div className="ast-container">
        <div id="primary" className="content-area primary">
          <main id="main" className="site-main">
            <article className="page type-page status-publish ast-article-single">
              <header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
              <div ref={containerRef}>
                <div className="entry-content clear" itemProp="text">


                  <div data-elementor-type="wp-page" data-elementor-id="3604" className="elementor elementor-3604">
                    <div className="elementor-element elementor-element-6b65d076 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="6b65d076" data-element_type="container" data-e-type="container">
                      <div className="elementor-element elementor-element-92aae3b e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="92aae3b" data-element_type="container" data-e-type="container">
                        <div className="elementor-element elementor-element-2bcd08fe ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="2bcd08fe" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
                          <div className="elementor-widget-container">
                            <div className="ekit-wid-con">        {/* link opening */}
                              {/* end link opening */}

                              <div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
                                <div className="elementskit-box-header">
                                  <div className="elementskit-info-box-icon ">
                                    <img decoding="async" width="2560" height="1707" src="/assets/images/03/CNC07032-scaled.jpg" className="attachment- size-" alt="" srcSet="/assets/images/03/CNC07032-scaled.jpg 2560w, /assets/images/03/CNC07032-300x200.jpg 300w, /assets/images/03/CNC07032-1024x683.jpg 1024w, /assets/images/03/CNC07032-768x512.jpg 768w, /assets/images/03/CNC07032-1536x1024.jpg 1536w, /assets/images/03/CNC07032-2048x1365.jpg 2048w" sizes="(max-width: 2560px) 100vw, 2560px" />                </div>
                                </div>
                                <div className="box-body">
                                  <h3 className="elementskit-info-box-title">
                                    Decoration                </h3>
                                  <p>
                                  </p>
                                  <div className="box-footer disable_hover_button">
                                    <div className="btn-wraper">
                                      <Link className="elementskit-btn whitespace--normal" to="/kids-parties-decoration">
                                        EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </Link>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>				</div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-79069c72 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="79069c72" data-element_type="container" data-e-type="container">
                        <div className="elementor-element elementor-element-37680c8b ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="37680c8b" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
                          <div className="elementor-widget-container">
                            <div className="ekit-wid-con">        {/* link opening */}
                              {/* end link opening */}

                              <div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
                                <div className="elementskit-box-header">
                                  <div className="elementskit-info-box-icon ">
                                    <img decoding="async" width="1920" height="1080" src="/assets/images/01/cooked-dish.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/cooked-dish.jpg 1920w, /assets/images/01/cooked-dish-300x169.jpg 300w, /assets/images/01/cooked-dish-1024x576.jpg 1024w, /assets/images/01/cooked-dish-768x432.jpg 768w, /assets/images/01/cooked-dish-1536x864.jpg 1536w" sizes="(max-width: 1920px) 100vw, 1920px" />                </div>
                                </div>
                                <div className="box-body">
                                  <h3 className="elementskit-info-box-title">
                                    Games                </h3>
                                  <p>


                                  </p>
                                  <div className="box-footer disable_hover_button">
                                    <div className="btn-wraper">
                                      <a className="elementskit-btn whitespace--normal" href="/assets/images/06/TSR-Events-Menu-for-Birthday-and-House-Parties.pdf">
                                        EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>				</div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-350d70a2 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="350d70a2" data-element_type="container" data-e-type="container">
                        <div className="elementor-element elementor-element-1b6b1200 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="1b6b1200" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
                          <div className="elementor-widget-container">
                            <div className="ekit-wid-con">        {/* link opening */}
                              {/* end link opening */}

                              <div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
                                <div className="elementskit-box-header">
                                  <div className="elementskit-info-box-icon ">
                                    <img loading="lazy" decoding="async" width="1200" height="580" src="/assets/images/01/Barbecue-dish-item-1.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/Barbecue-dish-item-1.jpg 1200w, /assets/images/01/Barbecue-dish-item-1-300x145.jpg 300w, /assets/images/01/Barbecue-dish-item-1-1024x495.jpg 1024w, /assets/images/01/Barbecue-dish-item-1-768x371.jpg 768w" sizes="(max-width: 1200px) 100vw, 1200px" />                </div>
                                </div>
                                <div className="box-body">
                                  <h3 className="elementskit-info-box-title">
                                    Artists &amp; entertainment                </h3>
                                  <p>
                                  </p>
                                  <div className="box-footer disable_hover_button">
                                    <div className="btn-wraper">
                                      <a className="elementskit-btn whitespace--normal" href="/assets/images/06/TSR-Events-Menu-for-Birthday-and-House-Parties.pdf">
                                        EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>				</div>
                        </div>
                      </div>
                      <div className="elementor-element elementor-element-73385658 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="73385658" data-element_type="container" data-e-type="container">
                        <div className="elementor-element elementor-element-3236c0e9 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="3236c0e9" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
                          <div className="elementor-widget-container">
                            <div className="ekit-wid-con">        {/* link opening */}
                              {/* end link opening */}

                              <div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
                                <div className="elementskit-box-header">
                                  <div className="elementskit-info-box-icon ">
                                    <img loading="lazy" decoding="async" width="1200" height="580" src="/assets/images/01/Barbecue-dish-item-1.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/Barbecue-dish-item-1.jpg 1200w, /assets/images/01/Barbecue-dish-item-1-300x145.jpg 300w, /assets/images/01/Barbecue-dish-item-1-1024x495.jpg 1024w, /assets/images/01/Barbecue-dish-item-1-768x371.jpg 768w" sizes="(max-width: 1200px) 100vw, 1200px" />                </div>
                                </div>
                                <div className="box-body">
                                  <h3 className="elementskit-info-box-title">
                                    Rental Equipments                </h3>
                                  <p>
                                  </p>
                                  <div className="box-footer disable_hover_button">
                                    <div className="btn-wraper">
                                      <a className="elementskit-btn whitespace--normal" href="/assets/images/06/TSR-Events-Menu-for-Birthday-and-House-Parties.pdf">
                                        EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>				</div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-71d68f18 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="71d68f18" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
                      <div className="elementor-element elementor-element-6745633a e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="6745633a" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
                        <div className="e-con-inner">
                          <div className="elementor-element elementor-element-14ce1e1c e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="14ce1e1c" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
                                                        <EnquiryHeading widgetElementId="2a618e79" />

                                                        <EnquiryForm widgetElementId="54bc8abf" />

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </article>
          </main>
        </div>
      </div>
    </div>
  )
}

export default KidsSpecialEventsDecorationMenu
